import { Wrap } from './styles';

import InputBase from '@material-ui/core/InputBase';
import { forwardRef } from 'react';
import MaskedInput from 'react-text-mask';

/**
 * MaskedTextField
 * 
 * @param {*} props Resto
 * @param {*} ref referencia
 * 
 * @returns um component 
 */
const MaskedTextField = forwardRef((props, ref) => {
  /**
   * Componente para aplicação de máscaras em inputs
   */
  return (
    <Wrap ref={ref}>
      {props.label ? <label htmlFor={props.name}>{props.label}</label> : null}
      <MaskedInput
        mask={props.mask}
        placeholder={props.placeholder}
        id={props.name}
        {...props}
        render={(ref, props) => <InputBase inputRef={ref} {...props} />}
      />
      {props.error && props.helperText ? (
        <div className="error">{props.helperText}</div>
      ) : null}
    </Wrap>
  );
});

export default MaskedTextField;
